import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { Modal, Button, Table } from 'antd';
import { SyncOutlined } from '@ant-design/icons';
import API from '../../../services/API';

export default function PatchStatementModal() {

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errors, setErrors] = useState([]);

  let { userId } = useParams();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const loadErrors = async () => {
    setErrors(null);
    const errors = await API.getFurnishingErrors({ userId });
    setErrors(errors);
  };

  useEffect(() => {
    loadErrors();
  }, []);

  return (
    <>
      <Button type="danger" onClick={showModal} style={{ marginLeft: "auto" }} block>
        Bloom Errors{errors?.length > 0 && ` (${errors.length})`}
      </Button>
      <Modal width="1600px" title="Bloom Errors" open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
        <Table dataSource={errors} columns={[
            {
                title: 'Type',
                dataIndex: 'apiType',
                key: 'apiType',
            },
            {
                title: 'Error',
                dataIndex: 'error',
                key: 'error',
            },
            {
                title: 'Detail',
                dataIndex: 'errorDetail',
                key: 'errorDetail',
            },
            {
                title: 'Time',
                dataIndex: 'createTs',
                key: 'createTs',
            },
        ]} />
        <Button type="primary" ghost icon={<SyncOutlined />} onClick={loadErrors}>Refresh</Button>
      </Modal>
    </>
  );
}